import { LOCALES } from "../locales";

export const portuguese_messages = {
  [LOCALES.PORTUGUESE]: {
    //Mobile Login Screen Text
    mobileLoginScreenTitle: "Prezado usuário",
    mobileLoginScreenText: "Para obter a melhor experiência, você deve acessar o MyDNA de um computador ou notebook.",

    //MenuHeader
    homepage: "Início",
    vacancies: "Vagas",

    //HomePagePersonal
    workAs: "Trabalho como",
    areasInterest: "Áreas de Interesses",
    selectArea: "Selecionar Área",
    myResume: "Meu Resumo",
    showVacancies: "Ver Vagas",
    salaryConsult: "Consulta Salarial",

    //FormationExperience
    formationDesc:
      "Aqui você deve criar e preencher suas últimas experiências profissionais, focando nas Funções e Realizações de cada período, lembre-se de ser claro, preciso e tangível",

    //loading
    loadingP1: "carre",
    loadingP2: "gando",

    //defaultLevel
    nullLevel: "Nulo",
    basicLevel: "Básico",
    intermediaryLevel: "Intermediário",
    advancedLevel: "Avançado",
    fluentLevel: "Fluente",

    //Presentation
    presentationTitle: "Apresentação",
    presentationDesc:
      "Faça um bom RESUMO de você para que todos o conheçam rapidamente lendo sobre você! Além disso, você pode enviar essas avaliações para suas redes sociais e junto com o vídeo de auto-apresentação, onde você pode falar sobre você e suas conquistas, é uma das melhores maneiras dos recrutadores te conhecerem.",
    aboutYou: "Sobre mim",
    writePresentationPH: "Digite um texto de Apresentação",
    socialMedia: "Redes Sociais",
    instagramLink: "Insira o link do seu Instagram",
    linkedinLink: "Insira o link do seu LinkedIn",
    facebookLink: "Insira o link do seu Facebook",
    uploadVideoLink: "Subir URL do Vídeo",
    uploadLetterPresentation: "Subir Carta de Apresentação",
    uploadFileDesc: "Clique para adicionar um arquivo ou arraste para cá",
    yourFile: "Seu Arquivo",
    yourFileTitle: "Baixar seu documento atual",
    yourFileDownload: "Baixar",
    videoPresentation: "Vídeo de Apresentação",

    //SMTM
    smtmTitle: "Por SMTM, Part of MyDNA",
    smtmDesc: "Conheça seu salário com Show Me The Money",
    smtmText1:
      "Com certeza mais de uma vez você se perguntou se o seu salário está alinhado com o que o mercado oferece. Como você poderia saber essa resposta? O Show Me The Money, em conjunto com o MyDNA, foi desenvolvido para responder a esta questão da forma mais rápida e pragmática, através de relatórios personalizados e atualizados em tempo real.",
    smtmText2: "Nossas fontes de dados:",
    smtmText3: "* Entrevistas de emprego realizadas por Headhunters, parte do MyDNA em cada país.",
    smtmText4:
      "* Números cadastrados no Show Me The Money, que posteriormente são validados pelos nossos especialistas antes de entrarem na base de dados, garantindo a qualidade da informação.",
    smtmText5: "* Aplicativo RPA para extrair automaticamente dados salariais do mercado",
    smtmText6: "O que você está esperando para saber seu valor de mercado?",
    smtmBtn: "Gerar Relatório Salarial",

    //Genes
    genesDesc: "A Solução Digital que o orienta no seu processo de Reinserção Laboral",
    genesText1:
      "Mydna Outplacement é um programa de trabalho digital - com um importante toque humano - que apoia os profissionais na transição bem-sucedida ou no desenvolvimento da carreira.",
    genesText2: "* Plano personalizado de acordo com a necessidade do profissional, mesclando Plataforma Digital com suporte de Especialistas do mercado de trabalho.",
    genesText3: "* Pessoas que fazem seu programa de Outplacement com MyDNA encontram um novo desafio profissional em até 50% do tempo médio do seu perfil.",
    genesBtn: "Realizar pova Grátis",

    //Jobs
    relatedJobs: "Vagas Relacionadas",
    relatedJobsDesc:
      "Nossos Robôs trabalham 24x7 mapeando as vagas abertas no mercado para que você possa se candidatar a novos desafios profissionais. Centralizamos aqui milhares de vagas, onde você pode pesquisar através de filtros. Ao se inscrever, as empresas saberão automaticamente do seu interesse nesta oportunidade! Desejamos muito sucesso nos processos!",
    searchInputJobsPH: "Pesquise por nome ou ID da vaga",
    searchWithFilterText: "Pesquisa com filtro",
    showAllJobs: "Ver todos",
    jobsOportunityText: "oportunidades de vagas",
    applyToJobBnt: "Candidatar-se",
    removeApplyBtn: "Remover Candidatura",

    //Buttons
    saveButton: "Salvar",
    closeButton: "Fechar",
    backButton: "Voltar",
    nextButton: "Seguinte",
    createButton: "Criar",
    accessButton: "Acessar",
    performTest: "REALIZAR TESTE",
    showResult: "VER RESULTADO",
    deleteButton: "Deletar",
    cancelButton: "Cancelar",
    yesText: "Sim",
    noText: "Não",
    selectOption0: "Selecionar...",
    clickHere: "Clique aqui",

    //Modal
    confirmDelete: "Confirmar Exclusão",

    //FormattedMessages
    country: "País",
    industry: "Indústria",
    area: "Área",
    role: "Cargo",
    professionalResponsableTitle: "Designar um Colaborador",
    noOcurrences: "Todavia no hay ocurrencias",
    complaintDetail: "Detalhe sua denúncia",

    //EmptyInfo
    incompleteTest: "O Colaborador ainda não realizou teste",
    incompleteProfile: "O Colaborar ainda não completou o perfil",
    emptyDesempeno: "Ainda nao há uma avaliacao disponível.",

    //Login Screen
    textLogin: "Faça o login com seu endereço de e-mail",
    createAccount: "Criar nova conta",
    login: "Iniciar Sessão",
    errorUserPass: "Nome de Usuário ou Senha incorreta!",
    passPH: "Senha",

    //Card Content
    customerRating: "Avaliação dos Clientes",

    mainMenuFeed: "Feed",
    mainMenuProfile: "Perfil",
    mainMenuMoment: "Momento",
    mainMenuVacancies: "Vagas",
    mainMenuCompany: "Para Empresas",
    mainMenuSearch: "Buscar pessoas e empresas",
    mainMenuSeeMore: "Ver mais",
    dropdownCompany: "Minha Empresa",
    dropdownLogout: "Sair",
    dropdownProfile: "Editar Perfil",
    searchByName: "Buscar por Nome",

    // Body Text
    textServices: "Serviços de ",
    textCertified: " certificados por MyDNA",
    ourProducts: "Nossos Produtos:",
    customerEvaluation: "Avaliação de Clientes",
    apresentationDown: "Baixar Apresentação",

    // HeaderText
    myPartnes: "Partnes",

    /** WheelCompany */
    seeMore: "Ver mais",
    myBusiness: "Minha Empresa",
    peopleAnalytics: "People Analytics",
    myCollaborators: "Meus Colaboradores",
    collaboratorsRegister: "Registro de Colaborador",
    massiveRegister: "Registro Massivo",
    mySolutions: "Minhas Soluções",

    onBoarding: "Onboarding",
    knowBadgeHeroes: "Conheca Badge Heroes",
    onBoardingRegister: "Registrar Onboarding",

    trainingAndDevelopment: "Treinamentos",
    manageTrainings: "Gerenciar Treinamentos",
    workoutsMydna: "Treinamentos by MyDNA",
    ebooksAndContent: "Ebooks & Conteudos",

    climeAndCulture: "Clima & Cultura",
    culture: "Cultura",

    cultureSurvey: "Pesquisa de Cultura",
    cultureSurveyText:
      "A avaliação da cultura fornece três informações-chave: qual é sua cultura, qual é a cultura da empresa e, portanto, qual é a correspondência entre as duas. Clique no botão e selecione as melhores respostas!",
    climeSurvey: "Pesquisa de Clima",
    climeSurveyText:
      "Faça sua voz ser ouvida! Aqui você pode dizer à sua empresa qual é a sua percepção do clima em sua organização. Será divertido, gratificante e levará apenas alguns minutos, e gerará muito valor para todos - você em primeiro lugar e acima de tudo. Clique no botão e deixe sua opinião!",
    nps: "NPS",
    businessCulture: "Cultura Empresarial",

    questionCulture: "Perguntas de Cultura",
    questionCarrer: "Perguntas de Carreira",
    questionLeader: "Perguntas de Liderança",
    questionInterests: "Perguntas de Interesse",

    performanceAnalysis: "Análise de Desempenho",
    performanceEvaluation: "Avaliação de Desempenho",

    salariesAndBenefits: "Salários & Benefícios",
    unitReport: "Relatório Unitário",
    knowPaybalance: "Conheça Paybalance",
    goPaybalance: "Acesse Paybalance",

    professionalDevelopment: "Assessement Center",
    motivacionalTest: "Teste de Motivações",
    knowMyco: "Conheça Myco",
    skillTest: "Teste de Habilidades",
    englishLevelTest: "Teste Nível de Inglês",

    careerPlan: "Plano de Carreira",
    presentacion: "Apresentação",
    referencias: "Referências",
    careerProjection: "Projeção de Carreira",
    jobDescriptor: "Descrição de Cargos",
    vacancies: "Vagas",

    ombudsman: "Ombudsman",

    outplacement: "Plano de Saída",
    knowGenes: "Sobre Genes",
    realocation: "Outplacement",
    leaveSearch: "Pesquisa de Saída",
    posicionesTitle: "Salários por Colaborador",
    benefits: "Benefícios",
    emotionalSalary: "Salário Emocional",

    activeService: "Ativar Serviço",

    //WheelCollaborator
    professionalHistoric: "Histórico Profissional",
    purpose: "Propósito",
    formation: "Formação",
    culture: "Cultura",
    salary: "Salário",
    habilities: "Habilidades",
    motivacions: "Motivações",
    performance: "Desempenho",
    training: "Conhecimentos",
    aData: "à data",
    functionsTitle: "Funções",
    achievementsTitle: "Conquistas",
    currentJobTitle: "Trabalho atual",
    functionsDescriptions: "Descreva aqui suas funçoes",
    achievementsDescriptions: "Descreva aqui suas conquistas",
    editProfile: "Editar Perfil",
    salarySurvey: "Pesquisa Salarial",
    outplacement: "Outplacement Digital",
    jobs: "Vagas",
    myResume: "Meu Resumo",

    //Professional Historic
    collaboratorTrajectory: "Trajetória do Colaborador",
    experienceTime: "Tempo de Experiência",
    yearsAnd: "Anos e",
    months: "Meses",
    workedIndustries: "Setores da Indústria em que Trabalhou",
    workedPositions: "Cargos Ocupados",

    //Proposito
    purposeToWork: "Os Propósitos de trabalho são",

    //Formation
    education: "Educação",
    englishLevel: "Nível de Inglês",

    //English Line Level
    englishNulo: "Nulo",
    englishBasic: "Essencial",
    englishIntermedio: "Intermedio",
    englishAvanzado: "Avançado",
    englishFlued: "Fluente",

    //Culture
    commercial: "Comercial",
    commercialText:
      "Alinha-se melhor em empresas com as seguintes características: Orientação para o alcance de resultados. O ambiente, em parte, motiva os funcionários a cumprir as metas. O estilo de liderança motiva, mas você pode colocar mais agressividade comercial. Há competitividade na equipe, mas pode ser melhorada. As relações com os clientes são estabelecidas, mas nem sempre de longo prazo. Observa-se na equipe uma maior satisfação por conquistar e conquistar o mercado. Há desafios para crescer, mas você pode ser mais ambicioso.",
    disruptive: "Disruptiva",
    disruptiveText:
      "Alinha-se melhor com empresas com as seguintes características: Estilo de organização mais inovador, ouvindo e trabalhando mais em equipe. Está planejado mais a longo prazo. A liderança é mais motivadora, mais arriscada, mais empreendedora. As equipes começam a ser mais visionárias e com fome de sair da caixa. Há maior tolerância à diversidade e às diferenças entre as equipes. A expressão liberdade de fazer começa a ser mais ouvida.",
    collaborative: "Colaborativa",
    collaborativeText:
      "É o melhor classificado em empresas com as seguintes características: Estilo organizacional pouco estruturado. Tem uma estrutura piramidal, onde as decisões são tomadas por poucos. A comunicação das decisões ou estratégia é lenta, conhecida por poucos e geralmente cabeças. Alguns protocolos e procedimentos estão disponíveis. Procura-se estabilidade e permanência ao longo do tempo. A eficiência é um pilar para a tomada de decisões.",
    traditional: "Tradicional",
    traditionalText:
      "Alinha-se melhor com empresas com as seguintes características: Estilo organizacional com foco nas pessoas. Preocupado em gerar um ambiente de trabalho agradável e próximo. O desenvolvimento profissional faz parte dos desafios permanentes. Liderança incentivando o trabalho em equipe. Há alta comunicação entre gestores e colaboradores. A estratégia é conhecida de todos. Equipes alinhadas e comprometidas com a empresa.",
    culturePreview: "tem o seguinte Perfil Cultural",

    //Salario
    actualSalary: "Salário Atual",
    fixedSalary: "Fixo Mensal",
    variableAnualSalary: "Variável Anual",
    titlePosiciones: "Salários por Colaborador",

    //Career Plan
    hierarchicalLevel: "Nível Hierárquico",
    nextLevel: "Próximo Nível (recomendado)",
    actualLevel: "Nível Atual -",
    possibleAreas: "Possibilidades de Trocas de Áreas",
    collaboratorTextP1: "Colaboradores com experiência na área de",
    collaboratorTextP2: "podem possuir conhecimentos e habilidades para trabalhar na área de",
    director: "Diretor",
    manager: "Gerente",
    submanager: "Subgerente",
    boss: "Coordenador",
    specialist: "Especialista",
    analist: "Analista",
    technical: "Operário / Técnico / Assist.",

    //Onboarding
    collStatus: "Em Progresso",
    assignStatus1: "Tem",
    assignStatus2: "registrado(s)",
    collEmpty: "Não há colaboradores cadastrados, cadastre seus colaboradores para começar",
    responsable: "Responsável",
    registerResponsable: "REGISTRAR NOVO RESPONSÁVEL",
    registerCollaborator: "REGISTRAR NOVO COLABORADOR",

    onboardingAlertAnswer: "Não há respostas",

    statusOnboardingQuestion1: "Segue em Onboarding?",
    statusOnboardingQuestion2: "Como se sente em relacao ao processo?",
    statusOnboardingQuestion3: "Quantidade de etapas feitas?",
    statusOnboardingQuestion4: "Esta ativo no programa?",
    statusOnboardingQuestion5: "Em quanto tempo termina o Onboarding?",
    statusOnboardingQuestion6: "Acredita que o programa de Onboarding esta ajudando?",
    statusOnboardingQuestion7: "Avanço Geral do Programa",

    statusOnboardingAnswerYes: "Sim",
    statusOnboardingAnswerNo: "Não",

    //Capacitations
    capacitationTitle: "Capacitação",
    capacitationCol: "Treinamento",
    capacitationAreaCol: "Área",
    capacitationProgress: "Progresso",
    capacitationsTitle: "Capacitações",
    capactitationSearchPlaceHolder: "Buscar curso por nome e/ou palavra-chave",
    capacitationChooseArea: "Escolha a área de Capacitação",
    newCourse: "Criar Novo Curso",
    capacitationCourse: "Cursos",
    capacitationArea: "Área",
    capacitationEmpty: "Nenhuma capacitação registrada",

    //Trainnings
    trainningTitle: "Treinamentos by Mydna",

    //Trainning List
    //English
    trainningCardTitleEnglish: "Aulas de Inglês",
    trainningCardTextEnglish: "Aulas de Inglês para seus colaboradores",
    //Comercial & Selling
    trainningCardTitleComercialSelling: "Treinamento Pitch Comercial & Vendas",
    trainningCardTextComercialSelling: "Treinamento Pitch Comercial & Vendas para seus colaboradores.",
    //Gamefied Trainning
    trainningCardTitleGamefied: "Ferramenta de Treinamento Gameficado",
    trainningCardTextGamefied: "Crie seu próprio treinamento personalizado. Entregamos uma experiência totalmente gamificada aos seus colaboradores.",

    //Empy Content Book
    empyContentText: "Ainda não há conteúdo para ser exibido.",

    //DashBoard Clime
    dashboardClimeTitle: "DashBoard - Pesquisa de Clima",
    emptyInformationClime: "Nenhuma Pesquisa de Clima foi respondida ainda",
    textInformationBusinessCulture: "Ter candidatos alinhados com a cultura da sua empresa melhora a felicidade dos funcionários, reduzindo a rotatividade.",
    textInformationBusinessCulture2: "Responda as perguntas sobre cultura, carreira, liderança e interesses e você saberá qual é a cultura empresarial da sua empresa.",

    //BusinessCultureQuestions
    //Cultural
    businessCulturalQ1: "Somos reconhecidos pela forma como reciclamos, cuidamos do meio ambiente e fazemos uso inteligente dos recursos",
    businessCulturalQ2: "Costumamos nos vestir e nos expressar de maneira formal.",
    businessCulturalQ3: "Temos 50% de homens e 50% de mulheres em posições de liderança na linha de frente",
    businessCulturalQ4: "Temos diretores e/ou executivos seniors abertamente gays",
    businessCulturalQ5: "Somos reconhecidos como uma organização altamente inovadora",
    businessCulturalQ6: "Temos números de telefone e e-mails para que os funcionários possam fazer reclamações de forma confidencial",

    //Career
    businessCareerQ1: "Para ter sucesso aqui, você tem que ser competitivo.",
    businessCareerQ2: "Procuramos pessoas que valorizem mais o seu desenvolvimento profissional do que uma alta remuneração financeira",
    businessCareerQ3: "Com alta performance, as pessoas assumem rapidamente posições de poder (a cada 2 anos uma promoção)",
    businessCareerQ4: "Para ter sucesso aqui, você deve ser politicamente correto na forma como apresenta seus pontos de vista.",
    businessCareerQ5: "Usar tatuagens, brincos ou sua aparência física pode tornar um pouco mais difícil para você alcançar posições de alto nível.",
    businessCareerQ6: "Ter conversas sobre desenvolvimento de carreira com funcionários não é uma prioridade no momento",

    //Leader
    businessLeaderQ1: "Nossos cargos executivos ou gerenciais contam com vagas privilegiadas ou especiais de estacionamento",
    businessLeaderQ2: "Se estivermos sob pressão, a comunicação às vezes pode se tornar mais difícil",
    businessLeaderQ3: "Nosso Gerente Geral e Diretor não é reconhecido por estar próximo das pessoas",
    businessLeaderQ4: "Liderança é o tema mais importante em nossa estratégia corporativa",
    businessLeaderQ5: "Nossas equipes são tão apaixonadas que às vezes trabalham mais horas do que o normal",
    businessLeaderQ6: "Faz parte da nossa cultura que os gerentes peçam feedback às suas equipes sobre como melhorar sua liderança e gestão.",

    //Interests
    businessInterestsQ1: "Os sindicatos são um ator-chave para ouvir os funcionários",
    businessInterestsQ2: "Temos horário flexível (escolha o horário de entrada e saída)",
    businessInterestsQ3: "Temos sextas-feiras curtas (sair mais cedo às sextas-feiras)",
    businessInterestsQ4: "Concedemos dias de folga além do legal se nossos funcionários se casarem ou celebrarem um Acordo de União Civil",
    businessInterestsQ5: "Somos reconhecidos por oferecer benefícios melhores do que os do mercado para mulheres no pré e pós-natal",
    businessInterestsQ6: "Apoiamos as comunidades desportivas dos nossos colaboradores",

    //Promoter Score
    netPromoteScoreTitle: "Net Promote Score",
    detractorTitle: "Detratores",
    detractorText:
      "Os que não estão satisfeitos. Qualquer um que não se qualifique acima, provavelmente, tem algo para reclamar. Além disso, eles até tendem a falar mal do empresa para seus contatos. Sem falar que não são fiéis, a qualquer momento podem definitivamentedeixar a empresa.",
    neutralTitle: "Neutros",
    neutralText:
      "Eles não podem ser considerados insatisfeitos, mas não há garantia de que serão leais. Eles provavelmente têm algum ponto a melhorar, mas isso não significa que eles queiram ou pensem em sair da empresa. Ao mesmo tempo, eles não são perfeitamente leais, o que pode transformá-los em detratores, se algo acontecer ou perceberem que podem melhorar em outro lugar.",
    promotorTitle: "Promotores",
    promotorText: "São os mais leais, com tendência a recomendar a empresa. Embora a nota 9 indique que algo pode ser melhorado, não compromete a lealdade.",

    //Culture Business
    businessCultureTitle: "Cultura Empresarial",
    asksTimelineText: "Marque o que você planeja em sua vida profissional e o que você pensa sobre sua última/atual empresa",
    //Timeline
    cbTimelineStart: "Início",
    cbTimeLineQuestions: "Perguntas de Cultura",
    cbTimeLineCareer: "Perguntas de Carreira",
    cbTimeLineLeader: "Perguntas de Liderança",
    cbTimeLineInterests: "Perguntas de Interesses",
    cbTimeLineReportDelivery: "Entrega de Relatórios",

    //TimeLine Finished
    cbTimeLineAswer: "Sua Cultura Empresarial é",
    cbTimeLineComercial: "Comercial",
    cbTimeLineComercialDesc:
      "Orientação para alcançar resultados. O ambiente, em parte, motiva os funcionários a cumprir as metas. Pode melhorar. O estilo de liderança motiva, mas você pode colocar mais agressividade comercial. Há competitividade na equipe, mas pode ser melhorada. As relações com os clientes são estabelecidas, mas nem sempre de longo prazo. Observa-se na equipe uma maior satisfação por conquistar e conquistar o mercado. Há desafios para crescer, mas você pode ser mais ambicioso.",
    cbTimeLineDisruptive: "Distuptiva",
    cbTimeLineDisruptiveDec:
      "Estilo organizacional mais inovador, ouvindo e trabalhando mais em equipe. Está planejado mais a longo prazo. A liderança é mais motivadora, mais arriscada, mais empreendedora. As equipes começam a ser mais visionárias e com fome de sair da caixa. Há maior tolerância à diversidade e às diferenças entre as equipes. A expressão 'liberdade de fazer' está começando a ser mais ouvida.",
    cbTimeLineColaborate: "Colaborativa",
    cbTimeLineColaborateDesc:
      "Estilo organizacional com foco nas pessoas. Preocupado em gerar um ambiente de trabalho agradável e próximo. O desenvolvimento profissional faz parte dos desafios permanentes. Liderança incentivando o trabalho em equipe. Há alta comunicação entre gestores e colaboradores. A estratégia é conhecida de todos. Equipes alinhadas e comprometidas com a empresa.",
    cbTimeLineTraditional: "Tradicional",
    cbTimeLineTraditionalDesc:
      "Estilo organizacional pouco estruturado. Tem uma estrutura piramidal, onde as decisões são tomadas por poucos. A comunicação das decisões ou estratégia é lenta, conhecida por poucos e geralmente cabeças. Alguns protocolos e procedimentos estão disponíveis. Procura-se estabilidade e permanência ao longo do tempo. A eficiência é um pilar para a tomada de decisões.",

    //EmployerPerformance
    employerPerformanceTitle: "Avaliação de Desempenho",
    employersShowCollumTitle: "Colaboradores",
    employerCriterionCollumTitle: "Critério",
    employerWeigthCollumTitle: "Peso",
    employerExecutedCollumTitle: "% Executada",

    //ShowMeTheMoney
    salaryConsultTitle: "Consultoria Salarial Personalizada",
    salaryConsultText: "Preencha as informações a seguir e forneceremos um relatório adaptado aos salários de seus colaboradores.",
    salaryConsultErrorEmptyFields: "ERRO! Certifique-se de que todos os campos estão preenchidos.",
    salaryConsultErrorIncompatibleSalary: "ERRO! Salário incompatível com o cargo.",
    salaryConsultSuccessful: "Relatório enviado, verifique seu e-mail!",
    salaryConsultResponsableName: "Nome do Responsável que receberá o Relatório Salarial",
    salaryConultResponsableEmail: "Email do Responsável",
    salaryConsultEducationLevel: "Escolaridade",
    salaryConsultExperienceYears: "Anos de Experiência na Posição",
    salaryConsultExperienceThreeLess: "Menos de 3 anos",
    salaryConsultExperienceThreeOrSeven: "Entre 3 e 7 anos",
    salaryConsultExperienceSevenOrMore: "Mais de 7 anos",
    salaryConsultEnglishLevel: "Nível de Inglês",
    salaryConsultEnglishAloof: "Indiferente",
    salaryConsultEnglishBasic: "Básico",
    salaryConsultEnglishMid: "Intermediário",
    salaryConsultEnglishHigh: "Avançado",
    salaryConsultGrossMonthly: "Salário Bruto Mensal",
    salaryConsultAnnualBonus: "Bônus Anual",
    salaryConsultButtonSend: "Enviar Relatório por Email",

    //CareerPlan Section
    careerPlanText: "Quero um profissional para ocupar o cargo de:",
    careerPlanPHRole: "ex: Coordenador",
    careerPlanPHArea: "ex: Comercial",
    careerPlanBtnSearch: "Buscar",
    careerPlanBtnClean: "Limpar",
    careerPlanPHNameColaborator: "Nome do Colaborador",
    careerPlanNextLevel: "Próximo Nível",
    careerPlanSameAreas: "Áreas Afins",

    //SearchDashBoard
    leaveSearchTitle: "Pesquisa de Saída",
    leaveSearchNotFound: "As pesquisas de saídas ainda não foram respondidas",

    //AddEmployer
    assignCollaborator: "Designar um Colaborador",
    collaboratorTitle: "Colaborador",
    nullEmployersRegister: "Não há empregados registrados",

    //NewClass
    createNewClass: "Criar Novo Curso",
    className: "Nome do Curso",
    classLink: "Link do Curso",
    courseDescription: "Descrição",

    //Denuncia
    complaintSecurityText: "Você está em um espaço seguro",
    complaintSecuryTextBody: "Este é um canal totalmente confidencial entre você e o MyDNA. Tentaremos ajudar sem revelar seus dados.",
    btnComplaint: "Criar uma Reclamação",
    complaintTypes: "Motivo da Denúncia",
    complaintGenerate: "Enviar mensagem confidencial",
    complaintOptionA: "Discriminação trabalhador.",
    complaintOptionB: "Culpar o trabalhador.",
    complaintOptionC: "Isolamento do trabalho.",
    complaintOptionD: "Desrespeito no trabalho e insultos.",
    complaintOptionE: "Em relação às tarefas atribuídas.",
    complaintOptionF: "Difamação profissional e/ou pessoal.",
    complaintOptionG: "Sobrecarga de trabalho.",
    complaintOptionH: "Assédio sexual",
    complaintOptionI: "Rebaixar as funções do trabalhador.",
    complaintOptionJ: "Burnout",
    complaintOptionK: "Abuso trabalhista.",
    complaintOptionL: "Outro (Especifique)",

    //BE2
    //Personal Info

    // CardSection Title
    collaborator360: "Colaborador 360°",
    dashboardCompany: "Dashboard Empresa",
    executiveSearch: "Executive Search",
    middleTopManagement: "Middle & Top Management",
    backoffandStaff: "Backoff & Staff",
    plataformOnboardinGamified: "Plataforma de Onboarding Gamificado",
    englishClass: "Aulas de Inglês",
    commercialTraining: "Treinamento de Pitch Comercial e Vendas",
    gamefiedTraining: "Ferramenta de Treinamento Gamificada",
    cultureReport: "Relatório de Cultura",
    culturalFitEmp: "Fit Cultural Candidados",
    culturalFitCol: "Fit Cultural Colaboradores",
    culturalTransformation: "Transformação Cultural",
    realTimeConsult: "Consulta em Tempo Real",
    customStudy: "Estudo Personalizado",
    variableSalary: "Estudo de Remuneração Variável",
    salaryGuide: "Guia Salarial",
    salaryProjection: "Projeção Salarial",
    topManagement: "Top Management",
    middleManagement: "Middle Managment",
    backofficeOutput: "Backoffice & Staff (Saida)",
    searchOutput: "Pesquisa de Saida",

    //Jobs Description
    jobsDescriptionTitle: "Descrição de Cargos",
    jobsDescriptionShowMore: "Ver descrição",
    jobsDescriptionReturn: "Voltar a lista de cargos",
    jobsDescriptionTitleJob: "O que faz um ",
    jobsDescriptionActivies: "Quais são as suas Principais Atividades",
    jobsDescriptionFormation: "Perfil Técnico / Experiência / Formação Acadêmica",
    jobsDescriptionPersonal: "Perfil Pessoal",
    jobsDescriptionRelacion: "Nível de Relação",
    jobsDescriptionLanguage: "Idioma",
    jobsDescriptionStudy: "Formação",

    //CardSection Text
    textCollaborator360: "O People Analytics mais completo com os principais indicadores para gestão de talentos em sua organização.",
    textDashboardCompany:
      "KPIs chave para a gestão de talentos na sua organização. Saiba onde a empresa está indo bem e onde há trabalho para melhorar com KPIs claros e bem definidos.",
    textExecutiveSearch:
      "Headhunting especializado em alta e média gestão com presença regional. Garante a contratação de profissionais que se adequem ao perfil da sua empresa, conseguindo um maior nível de empenho e um menor nível de turnover.",
    textMiddleTopManagement:
      "Recrutamento para cargos intermediários na pirâmide com rapidez e precisão. Procuram-se profissionais que se enquadrem no perfil da sua empresa, garantindo um maior nível de empenho e um menor nível de rotatividade.",
    textBackoffandStaff:
      "Recrutamento para cargos operacionais e técnicos com rapidez e precisão. Procuram-se profissionais que se enquadrem no perfil da sua empresa, garantindo um maior nível de empenho e um menor nível de rotatividade.",
    textPlataformOnboardinGamified:
      "Melhore o comprometimento e acelere o desenvolvimento de seus colaboradores com um software de gamificação que gera interação, educação, cultura e trabalho em equipe.",
    textEnglishClass: "Aprendizagem de inglês para seus colaboradores.",
    textCommercialTraining: "Treinamento de Pith Comercial para seus colaboradores.",
    textGamefiedTraining:
      "Crie seu próprio treinamento personalizado. Entregamos uma experiência totalmente gamificada aos seus colaboradores com conteúdo de treinamento selecionado por você.",
    textCultureReport: "Conheça a cultura da sua organização e compare a visão da empresa versus a de seus colaboradores.",
    textCulturalFitEmp: "Conheça a % de ajuste que a organização tem com seus colaboradores em relação ao seu propósito e cultura.",
    textCulturalFitCol: "Conheça a % de ajuste que a organização tem com seus candidatos em relação ao seu propósito e cultura.",
    textCulturalTransformation: "Onde você está hoje e para onde você quer ir? Caso a cultura atual da sua empresa não reflita o que você gostaria, nós te ajudamos.",
    textPerformanceAnalysis:
      "Avalie o desempenho de seus colaboradores, conheça os gaps e pontos fortes de suas equipes, defina a melhor estratégia de gestão de talentos com dados claros e quantitativos.",
    textRealTimeConsult:
      "Acesse o banco de dados salarial da Mydna com informações atualizadas de mercado para definir a melhor estratégia para sua organização. Consulta por tipo de empresa, cargo, experiência e Habilidades.",
    textCustomStudio:
      "Para aquelas vagas que ainda não encontra informação na nossa plataforma na área de “consulta em tempo real”, apoiamo-lo na recolha de informação de forma ágil e aconselhada pelas nossas equipas de especialistas.",
    textVariableSalary: "Defina a melhor estratégia de remuneração variável para sua organização juntamente com uma avaliação de desempenho.",
    textSalaryGuide: "Baixe o último Guia Salarial desenvolvido por PayBalance/Mydna",
    textMotivacionalTest: "Teste psicolaboral de motivações profissionais para descobrir o que realmente motiva seus colaboradores e/ou candidatos.",
    textSkillTest: "Teste psicolaboral de Habilidades profissionais para descobrir as soft skills que mais se destacam para os seus colaboradores e/ou candidatos.",
    textEnglishLevel: "Evalua el nivel de inglés de tus colaboradores con el apoyo de Nulinga. Un test de 20 minutos para conocer su dominio del idioma.",
    textCareerProjection: "Avalie o nível de inglês de seus colaboradores com o apoio da Nulinga. Um teste de 20 minutos para descobrir seu domínio do idioma.",
    textSalaryProjection: "Saiba quanto pagar no caso de promover um profissional aplicando as melhores estratégias de desenvolvimento e retenção profissional.",
    textJobDescriptor: "Conheça as habilidades e responsabilidades necessárias de cada cargo.",
    textTopManagement: "Assessoria para recolocação de profissional especializado em alta e média gerência.",
    textMiddleManagement: "Acesso à plataforma de outplacement digital especializada em posições intermediárias na pirâmide para rápida recolocação no mercado de trabalho.",
    textBackofficeOutput: "Acesso à plataforma de outplacement digital especializada em cargos de operador e técnicos para rápida recolocação no mercado de trabalho.",
    textSearchOutput: "Conheça a experiência de seus ex-colaboradores no momento de sua saída",
    textGenesCard: "Assessoria para a recolocação de um profissional",

    // PeopleAnalytics Session
    //MyCollaborators
    myCollaboratorsTitle: "Meus Colaboradores",
    searchCollaborator: "Buscar um Colaborador",
    notDoneCultureSearch: "Este colaborador ainda não respondeu à pesquisa de cultura",
    noCollaboratorsRegistered: "Ainda não há colaboradores cadastrados",

    //CollaboratoRegister
    collaboratorName: "Nome",
    collaboratorEmail: "E-mail",
    loadCollaborator: "Subir Colaborador",
    //MassiveRegister
    collBodyText: "Baixe o modelo de planilha excel, complete-o com as informações de seus colaboradores e faça o upload para o banco de dados.",
    collDownloadSheet: "Baixar o Modelo de Planilha",
    collUpSheet: "Subir arquivo de Planilha",
    collArchive: "Arquivo",

    //BadgeHeroes
    badgeHeroesTitle: "Badge Heroes",
    badgeHeroesTextCard:
      "Melhore o comprometimento e acelere o desenvolvimento de seus colaboradores com um software de gamificação que gera interação, educação, cultura e trabalho em equipe.",

    //Myco
    mycoTitle: "Testes de Habilidades e Motivações Profissionais",
    mycoTextCard: "Teste psicolaboral de Habilidades e motivações profissionais para conhecer as soft skills e o que realmente motiva os seus colaboradores.",

    //ProgressBar
    progressText: "Concluído",
    progressMyProfile: "Meu Perfil",
    progressProfileText: "Selecione a categoria que deseja iniciar",

    //Personal Info
    editProfileImg: "Editar foto de Perfil",
    professionalInformation: "Informação Profissional",
    personalInformation: "Informações Pessoais",
    personalCompanyCol: "Empresa",
    personalIndustryCol: "Indústria",
    personalAreaCol: "Área",
    personalEntryDate: "Data de Entrada",
    personalExitDate: "Data de Saída",
    personalHastaFecha: "Até o momento",
    //Education
    personalEducation: "Educação",
    personalEnglishLevel: "Nível de Inglês:",
    personalELNulo: "Nulo",
    personalELBasic: "Básico",
    personalELAverage: "Intermediário",
    personalELAdvanced: "Avançado",
    personalELFluent: "Fluente",
    personalUniversity: "Universidade",
    personalType: "Tipo",
    personalClass: "Curso",
    //Salary
    personalSalary: "Salário",
    personalFixBruteSalary: "Salário Fixo Atual:",
    personalCoin: "Moeda:",
    personalVariableSalary: "Salário Variável Anual:",

    //Purpose
    myPurposes: "Meus Propósitos",
    yourPurpose: "Seu Propósito",
    myPurposeText:
      "Compartilhe seus objetivos pessoais e profissionais, o que te motiva a ser uma pessoa e profissional melhor a cada dia. Através da assessoria digital, ajudaremos você a tornar seus objetivos realidade.",

    //Culture
    myCultureProfile: "Meu Perfil Cultural",
    myCultureText: "Conheça seu perfil cultural e as empresas em que você se encaixa e será feliz, de acordo com suas preferências profissionais.",

    //Competencias
    competenciaTitle: "Assessment Habilidades:",
    abilitiesCollaboratorTitleText: "Você quer conhecer suas Habilidades? Você pode fazer isso agora.",
    abilitiesCollaboratorTextP1: "Nosso teste avalia 11 Habilidades de sua personalidade, tais como",
    abilitiesCollaboratorTextP2: "Visão Estratégica, Liderança, Orientação ao Cliente, Trabalho em Equipe",
    abilitiesCollaboratorTextP3: " entre outras.",
    abilitiesCollaboratorTextEmail: "Você receberá um e-mail com o acesso ao teste online.",
    abilitiesCollaboratorDoubtsText: "Clique aqui novamente para ver os resultados (pode demorar até 24hrs após a conclusão do teste).",

    //Motivacions
    motivationTitle: "Assessment Motivações:",
    motivacionCollaboratorTitle: "O que o motiva? Descubra agora!",
    motivacionalCollaboratorTextP1: "Nosso teste avalia 17 fatores em sua área profissional que o motivam.",
    motivacionalCollaboratorTextP2: "Saber claramente o que o motiva é essencial para orientar sua carreira e sua vida",
    motivacionalCollaboratorTextP3: " Faça o teste agora!",

    //Performance
    performanceTitle: "Desempenho",
    perfomanceFinalResult: "Resultado Final:",

    //myKnowledge
    myKnowledgeTitle: "Meus Conhecimentos",
    myKnowledgeText:
      "Conte-nos sobre o conhecimento que você desenvolveu e o valor que pode oferecer ao mercado. Aqui entram todos os tipos de cursos, técnicos ou não, autoaprendizagem, etc.",
    assignKnowledge: "Agregar novo conhecimento",

    //Trainings
    ebooks: "E-books & Conteúdos",
    myTrainings: "Meus Treinamentos",
    createNewTraining: "Criar nova Capacitação",
    englishText: "Test de Inglês",
    nulingaText: "A plataforma de aprendizado de idiomas online projetada para o mundo corporativo.",
    typeKnowledge: "Tipo de Conhecimento",
    languageTrainingTitle: "Idioma",
    otherTrainingTitle: "Outro",
    levelKnowledgeTitle: "Nível de Conhecimento",

    //Employee Profile Edit
    profileError: "Campo obrigatório",

    //GoToPaybalance
    paybalanceTitle: "Acesse Paybalance",
    paybalanceDescription1: "Olá,",
    paybalanceDescription2: "Obrigado pela confiança no MyDNA!",
    paybalanceDescription3: "Aqui você terá acesso ao PayBalance by MyDNA, Plataforma de Informações Salariais em Tempo Real. Para isso você deve clicar no link abaixo:",
    paybalanceDescription4: "E entre com seu e-mail e senha, os mesmos do MyDNA, para poder usar todos os recursos do Paybalance.",
    paybalanceDescription5: "As equipes MyDNA e Paybalance irão apoiá-lo nesta jornada, você pode contatá-los em caso de dúvida:",
    paybalanceTxt: "Equipe",
    paybalanceBtn: "ACESSE PAYBALANCE",

    //KnowPaybalance
    KnowPaybalanceTitle: "Acesse Paybalance",
    KnowPaybalanceTextCard:
      "Acesse PayBalance by Mydna com informações atualizadas de mercado para definir a melhor estratégia para sua organização. Consulta por tipo de empresa, cargo, experiência e Habilidades.",

    //Outplacement
    outplacementAlertAnswer: "Não há respostas",
    outplacementQuestionOne: "Já encontrou emprego?",
    outplacementQuestionTwo: "Como se sente em relação ao processo?",
    outplacementQuestionThree: "Quantidade de candidaturas:",
    outplacementQuestionFour: "Está participando de entrevistas?",
    outplacementQuestionFive: "Em quanto tempo acredita encontrar um novo emprego?",
    outplacementQuestionSix: "Acredita que o programa está ajudando no processo?",
    outplacementQuestionSixPos: "Acredita que o programa ajudou no processo?",
    outplacementQuestionSeven: "Avanço no programa Genes:",
    outplacementAnswerYes: "Sim",
    outplacementAnswerNo: "Não",
    outplacementAnswerOne: "entrevista(s) no momento",
    outplacementAnswerTwo: "Não está realizando estrevistas no momento",
    outplacementAnswerThree: "Em",

    outplacementAnswerFour: "mês(es)",
    outplacementOservation: "Observaçao",

    //Ombudsman
    occurrences: "Ocorrências",
    noOccurrences: "Ainda sem ocorrências",
    ombudmanTextOne: "Essas informações são confidenciais e restritas a pessoas autorizadas dentro da empresa.",
    ombudmanTextTwo: "Para obter as informações, entre em contato com nossa equipe; uma vez que sua identidade tenha sido verificada, eles lhe fornecerão as informações.",
    ombudsmanBtn: "delivery@mydnadigital.com",

    //Campaign
    campaignTitle: "Campanha People Analytics",
    campaignTxt:
      'Após cadastrar os colaboradores na plataforma, você pode enviar o e-mail, selecionar o pessoal necessário e clicar em "ENVIAR" para fazer a entrega simultânea para as pessoas desejadas. Junto com isso entregaremos seus respectivos acessos a cada colaborador. No MyDNA Employee, cada colaborador poderá carregar todas as informações relevantes para que os responsáveis ​​pela gestão de talentos tenham à disposição dados como: histórico profissional, formação, pesquisa de clima, cultura, Habilidades, entre outros.',
    campaignMenu: "Campanha Colaborador",
    campaignTableName: "Nome",
    campaignTableMail: "E-mail",
    campaignTableArea: "Área",
    campaignTableJob: "Cargo",

    //Salarios y Beneficios
    salaryTitle: "Salarios por Cargo",

    //Internal Channel
    internalChannelTitle: "Canal de comunicação",
    internalChannelNewMessage: "Nova mensagem",
    internalChannelNoMessages1: "A caixa de saída está vazia, cria sua primeira mensagem",
    internalChannelNoMessages2: " para começar a se comunicar com os colaboradores",
    internalChannelSendedMessages: "Mensagens Enviadas",
    internalChannelReceivedMessages: "Mensagens Recebidas",

    //Internal Vacancies
    internalVacanciesTitle: "Vagas Internas",
    internalVacanciesCreate: "Criar vagas",
    internalVacanciesActive: "Vagas ativas",

    //MYCO Test
    mycoAbilitiesQ1: "Análise e Resolução de Problemas",
    mycoAbilitiesQ2: "Inovação",
    mycoAbilitiesQ3: "Pensamento estratégico",
    mycoAbilitiesQ4: "Orientação ao cliente",
    mycoAbilitiesQ5: "Liderança",
    mycoAbilitiesQ6: "Trabalho em equipe",
    mycoAbilitiesQ7: "Orientação a resultados",
    mycoAbilitiesQ8: "Plan. e Org.",
    mycoAbilitiesQ9: "Gestão de cambio",
    mycoAbilitiesQ10: "Auto desenvolvimento",
    mycoAbilitiesQ11: "Gerenciamento de estresse",

    mycoMotivationsQ1: "Orientação comercial",
    mycoMotivationsQ2: "Orientação ao alvo",
    mycoMotivationsQ3: "Orientação para a tipologia do trabalho realizado",
    mycoMotivationsQ4: "Orientação para inovação",
    mycoMotivationsQ5: "Aspecto econômico",
    mycoMotivationsQ6: "Autonomia e Versatilidade",
    mycoMotivationsQ7: "Segurança",
    mycoMotivationsQ8: "Prestígio",
    mycoMotivationsQ9: "Equilíbrio Profissional",
    mycoMotivationsQ10: "Satisfação no trabalho",
    mycoMotivationsQ11: "Comprometimento",
    mycoMotivationsQ12: "Carreira",
    mycoMotivationsQ13: "Desenvolvimento de habilidades",
    mycoMotivationsQ14: "Projeto Profissional",
    mycoMotivationsQ15: "Orientação de relações interpessoais",
    mycoMotivationsQ16: "Orientação do conceito",
    mycoMotivationsQ17: "Orientação de gerenciamento",

    //SalaryByRole
    salaryRoleEmployee: "Colaborador",
    salaryRoleCoin: "Moeda",
    salaryRoleSalary: "Salário Mensal",
    //SeniorityLevel
    salaryRoleSL1: "Indiferente",
    salaryRoleSL2: "Junior",
    salaryRoleSL3: "Pleno",
    salaryRoleSL4: "Sênior",
    //QualificationLevel
    salaryRoleQL1: "Indiferente",
    salaryRoleQL2: "Graduação",
    salaryRoleQL3: "MBA",
    salaryRoleQL4: "MBA Internacional",

    salaryRoleAlert: "Esta posição está sendo revisada. Para baixar o relatório tente novamente mais tarde",

    //DashboardClime&Benefits
    dashboardTextClimeBenefits: "A informação apresentada no dashboard reflete apenas a informação dos colaboradores a quem o salário foi informado",
    alertEmptyDashboard: "Olá! Você ainda não carregou as informações salariais do funcionário",

    //Benefits
    benefitsText: "Escolha a posição e descubra as vantagens que o mercado oferece para cada posição",
    benefitsSearchByCountry: "País da Posição do Colaborador",

    alimentationTitle: "Alimentação",
    alimentationText: "O valor médio é CLP $ 3.700 por dia",

    transportTitle: "Transporte",
    transportText: "O valor pode variar, dependendo da empresa e do salário base do trabalhador",

    lifeInsuranceTitle: "Seguro Complementar",
    lifeInsuranceText: "Suplemento ao plano de saúde com cobertura média de 500 UF por beneficiário",

    certificationTitle: "Certificações",
    certificationText: "Apoio económico para certificar Habilidades",

    vehicleTitle: "Veículo",
    vehicleText: "Benefício oferecido quando contribui ou utiliza seu veículo para a realização de atividades laborais",

    tradingPowerTitle: "% Trading Power Anual",
    tradingPowerText: "Como forma de reconhecer o profissional que ajudou a empresa a agregar valor, parte do lucro do período é entregue ao executivo",

    computerTitle: "Computador/Celular",
    computerText: "Eles são considerados ferramentas de trabalho e sua entrega está cada dia mais massiva.",

    gymTitle: "Academia",
    gymText: "Convênios com academias que permitem descontos ao colaborador",

    anualBonusTitle: "Bônus Anual por Resultados",
    anualBonusText: "O valor pode variar de acordo com a atuação do colaborador",

    bonusTitle: "Bônus",
    bonusText: "O valor pode variar de 33.000 a 300.000 CLP. Sendo a média em 60.000 CLP",

    equityTitle: "Equity",
    equityText: "A empresa oferece suas ações oficiais estratégicas da empresa, tornando-se parceira desta",

    stockOptionsTitle: "Stock Options",
    stockOptionsText: "A empresa oferece ao seu colaborador estratégico a opção de comprar ações da empresa a preços melhores do que os praticados no mercado",

    //EmotionalSalary
    emotionalSalaryText: "Escolha o tema relacionado ao salário emocional que o mercado entrega e descubra quais são os mais comuns",

    emotionalSalaryOptionSelect: "Escolha uma opção",

    //MyCompany
    companyDetails: "Detalhes da Empresa",
    companyLogo: "Carregar seu Logotipo",
    companyName: "Nome",
    companyDescription: "Descrição",
    companyAnualBilling: "Faturamento Anual",
    companyLocation: "Localização",
    companySize: "Tamanho da Empresa",
    companySize1: "Pequena",
    companySize2: "Média",
    companySize3: "Grande",
    companyEmployeeAmount: "Número de Empreados",
    companyContact: "Dados de Contato e Redes Sociais",
    companyPhone: "Telefone",
    companyWebPage: "Pag. Web",
    companyProducts: "Produtos da Empresa",
    companyAddProduct: "Adicionar Produto",
    companyContent: "Conteúdo",
    companyUpVideos: "Suba os vídeos da sua Empresa aqui",

    //InternalJobs
    internalJobStep1: "Area, Nível, Tempo de Experiência",
    internalJobName: "Nome da Vaga*:",
    internalJobArea: "Área(s) de Atuação*:",
    internalJobNivel: "Escolha o Nível Hierárquico*:",
    internalJobExperienceYears: "Anos de experiência requerida para a posição*:",
    internalJobOptionArea: "Selecione uma Área",
    internalJobOptionNivel: "Selecione uma Opção",

    internalJobStep2: "Descrição do Cargo",
    internalJobDescription: "Descrição",
    internalJobRequeriments: "Requerimentos",

    internalJobRequerimentsPlaceHolder: "Escreva aqui os demais requisitos e funções do cargo",

    internalJobTitle: "Vagas Internas",
    internalJobTableC1: "VAGAS",
    internalJobTableC2: "ÁREA",
    internalJobTableC3: "VER CANDIDATOS",
    internalJobSearchPlaceHolder: "Pesquisar por Vagas",
    internalJobShowMore: "Carregar mais...",
    internalJobEmptyJob: "Não há vagas",
    internalJobReturn: "VOLTAR À LISTA DE VAGAS",

    //HistoricProfessionalEE
    historicProfessionalEENameCompany: "Nome da Empresa",
    historicProfessionalEEAreaCompany: "Indústria",
    historicProfessionalEEOption0: "Selecionar...",
    historicProfessionalEEOption1: "Agroindustria",
    historicProfessionalEEOption2: "Autopartes",
    historicProfessionalEEOption3: "Bens de Consumo",
    historicProfessionalEEOption4: "Comunicação",
    historicProfessionalEEOption5: "Construção",
    historicProfessionalEEOption6: "Consultoria",
    historicProfessionalEEOption7: "Educação",
    historicProfessionalEEOption8: "Eletrônica",
    historicProfessionalEEOption9: "Energia",
    historicProfessionalEEOption10: "Farmaceutica",
    historicProfessionalEEOption11: "Engenharia",
    historicProfessionalEEOption12: "Agropecuaria",
    historicProfessionalEEOption13: "Eletro / Eletrônica",
    historicProfessionalEEOption14: "Logística e Transpote",
    historicProfessionalEEOption15: "Máquinas e Equipamentos Industriais",
    historicProfessionalEEOption16: "Manufatura",
    historicProfessionalEEOption17: "Lazer e Entretenimento",
    historicProfessionalEEOption18: "Publicidade",
    historicProfessionalEEOption19: "Química, Plástico e Petroquímica",
    historicProfessionalEEOption20: "Varejo",
    historicProfessionalEEOption21: "Setor Público",
    historicProfessionalEEOption22: "Seguros",
    historicProfessionalEEOption23: "Telecomunicação",
    historicProfessionalEEOption24: "Têxtil",
    historicProfessionalEEOption25: "TI",
    historicProfessionalEEOption26: "Veículos",
    historicProfessionalEEOption27: "Financeiro",
    historicProfessionalEEOption28: "Saúde",
    historicProfessionalEEOption29: "Veterinária",
    historicProfessionalEEOption30: "Internet",
    historicProfessionalEEOption31: "Jurídico",
    historicProfessionalEEOption32: "Linhas Aéreas",
    historicProfessionalEEOption33: "Mineração",
    historicProfessionalEEJob: "Cargo",
    historicProfessionalEEEntryDate: "Data de Entrada",
    historicProfessionalEEHierarchicalLevel: "Nível Hierárquico",
    historicProfessionalEEArea: "Área",
    EEMonth: "Mês",
    EEYear: "Ano",
    historicProfessionalEEActualJob: "Trabalho Atual",
    historicProfessionalEELeaveDate: "Data de Saída",
    professionalExperienceDesc:
      "Aqui você deve criar e preencher suas últimas experiências profissionais, focando nas Funções e Realizações de cada período, lembre-se de ser claro, preciso e tangível",

    //Salary
    salaryDesc:
      "Esta informação é confidencial! Ajude-nos a entender seu pacote atual e uma ideia de pretensão em um novo desafio, para que os recrutadores possam ter essas informações em seu processo.",
    lastSalaryAdjust: "Último Ajuste Salarial",
    salaryExpectation: "Expectativa Salarial",

    //References
    referencesTitle: "Referências",
    referencesText:
      "É sempre importante saber o que as pessoas que trabalharam com você pensam de você! Peça um depoimento em vídeo ou texto e registre aqui, essa opinião é muito importante!",
    addReferenceBtn: "Adicionar Referência",
    emptyReference: "Você ainda não registrou as referências.",

    //AddReference
    namePersona: "Nome da Pessoa",
    namePersonaPH: "Nome e Sobrenome",
    function: "Cargo",
    companyWorkTogetherPH: "Empresa que trabalharam juntos",
    workRelation: "Relação de trabalho",
    workRelation1: "Par",
    workRelation2: "Equipe",
    workRelation3: "Chefe",
    workRelation4: "Nenhuma",
    phoneReference: "Telefone",
    emailReference: "E-mail",
    recomendationVideo: "Vídeo de Referência",
    recomendationLetter: "Carta de Recomendação",
    videoTextReference: "Você tem um vídeo de sua referência falando sobre como é trabalhar com você? Insira o URL do vídeo aqui.",

    //FormationEE
    formationEENameUniversity: "Nome da Universidade",
    formationEEType: "Tipo",
    formationEEOption1: "Técnico",
    formationEEOption2: "Profissional",
    formationEEOption3: "Graduado",
    formationEEOption4: "MBA/Mestre",
    formationEEOption5: "Doutorado",
    formationEECourse: "Curso",
    formationEEEntryDateCourse: "Data de Admissão",
    formationEECurrentlyStuding: "Cursando Atualmente",
    formationEEYes: "Sim",
    formationEECurrentlyWorking: "Trabalho aqui atualmente",
    formationEELeaveDateCourse: "Data de Saída",
    personalAddInfo: "Treinamento",

    cultureDesc:
      "Responda as perguntas abaixo e nossos algoritmos identificarão seu perfil CULTURAL! Com isso vamos apresentar a você Empresas que podem combinar com você e você poderá se candidatar a organizações alinhadas ao seu perfil.",

    //ClimeQuestionsEE
    climeQuestionsEEH1: "Muito Insatisfeito",
    climeQuestionsEEH2: "Insatisfeito",
    climeQuestionsEEH3: "Satisfeito",
    climeQuestionsEEH4: "Muito Satisfeito",
    cultureQuestionsEEForMe: "Para mim",
    //Section1
    climeQuestionsEETitle1: "RECURSOS, MEIO AMBIENTE E CULTURA",
    climeQuestionEE1: "As relações pessoais com seus colegas geralmente são boas?",
    climeQuestionEE2: "A empresa e a liderança fornecem iniciativas, canais e ambientes suficientes para promover um bom relacionamento com seus colegas?",
    climeQuestionEE3: "Você possui os recursos, ferramentas e ambientes necessários, físicos ou digitais, para realizar suas tarefas e atingir seus objetivos?",
    climeQuestionEE4: "A cultura e os valores da empresa são consistentes com seus valores pessoais?",
    //Section2
    climeQuestionsEETitle2: "ATIVIDADES E FUNÇÕES EXECUTADAS",
    climeQuestionEE5: "O volume de trabalho realizado é adequado ao seu cargo e carga horária?",
    climeQuestionEE6: "Sua posição é consistente com suas habilidades, conhecimentos e senioridade profissional?",
    climeQuestionEE7: "Seus objetivos, tarefas e resultados declarados são claros?",
    climeQuestionEE8: "Suas responsabilidades são condizentes com o cargo que ocupa?",
    climeQuestionEE9: "Você tem clareza e percepção de valor do impacto das tarefas nos objetivos da empresa?",
    climeQuestionEE10: "O modelo de trabalho (presencial, híbrido ou home office) é adequado para o desempenho de suas funções?",
    //Section2
    climeQuestionsEETitle3: "LIDERANÇA",
    climeQuestionEE11: "Seu líder ouve e considera suas opiniões ao tomar decisões?",
    climeQuestionEE12: "A avaliação do seu desempenho e o reconhecimento das suas contribuições são adequados?",
    climeQuestionEE13: "Seu líder mantém um nível de exigência adequado ao seu cargo e carga de trabalho?",
    climeQuestionEE14: "Sua liderança possui o conhecimento técnico, habilidades gerais e suporte necessários para que você tenha sucesso em suas atividades?",
    climeQuestionEE15: "Você se sente à vontade para compartilhar dificuldades, desconfortos ou pedir feedback quando necessário?",
    //Section2
    climeQuestionsEETitle4: "OPORTUNIDADE E CARREIRA",
    climeQuestionEE16: "Existem motivações e desafios nas suas funções?",
    climeQuestionEE17: "Existe autonomia para aplicar suas habilidades e tomar decisões apropriadas às suas próprias custas?",
    climeQuestionEE18: "Existe possibilidade de promoção e/ou plano de carreira bem claro e definido?",
    climeQuestionEE19: "Há investimento da empresa em desenvolvimento de carreira?",
    climeQuestionEE20: "Existe espaço para expressar suas ambições e se candidatar a cargos dentro da organização?",
    climeQuestionEE21: "Há clareza sobre o que é necessário para crescer na empresa?",

    //Section2
    climeQuestionsEETitle5: "SALÁRIOS E BENEFÍCIOS",
    climeQuestionEE22: "A sua remuneração é adequada ao cargo que ocupa e às atividades que desenvolve?",
    climeQuestionEE23: "Os benefícios atendem às suas necessidades?",
    climeQuestionEE24: "Os processos de reembolso são claros e fáceis de executar?",
    climeQuestionsEETitle6: 'Por favor, responda às seguintes perguntas de 1 a 10, onde 1 indica "discordo totalmente" e 10 indica "concordo totalmente":',
    climeQuestionEE25: "Você recomendaria um amigo ou familiar para trabalhar nesta empresa?",

    climeQuestionsAlert:
      "IMPORTANTE: Sua empresa não terá acesso às suas respostas, apenas à média entre os colaboradores, desde que mais de 10 colaboradores tenham respondido a pesquisa, para manter o sigilo.",

    culturaQuestionEE1: "É importante para mim que haja um bom equilíbrio entre homens e mulheres em cargos de gestão.",

    //CultureQuestions
    cultureQuestionEE1: "Ser competitivo é a chave para ter sucesso no trabalho.",
    cultureQuestionEE2: "Se eu tiver que escolher entre desenvolvimento profissional versus salário, prefiro o desenvolvimento profissional.",
    cultureQuestionEE3: "Quero assumir posições mais poderosas rapidamente.",
    cultureQuestionEE4: "Cuidar do que você diz e ser politicamente correto ao dar sua opinião é a chave para ter sucesso no trabalho.",
    cultureQuestionEE5: "É importante esconder as tatuagens e cuidar da aparência física no trabalho para ter sucesso.",
    cultureQuestionEE6: "Se meu chefe não fala comigo sobre o desenvolvimento da minha carreira, eu entendo.",
    cultureQuestionEE7: "É compreensível que Diretores ou Gerentes tenham vagas privilegiadas de estacionamento.",
    cultureQuestionEE8: "É compreensível que a comunicação dos chefes às vezes se torne mais dura.",
    cultureQuestionEE9: "É compreensível que o Gerente Geral seja próximo de algumas pessoas e não de outras.",
    cultureQuestionEE10: "A questão da liderança é a mais importante.",
    cultureQuestionEE11: "Se eu fizesse parte de uma equipe de alto desempenho, trabalharia depois.",
    cultureQuestionEE12: "Adoro quando meu chefe me pergunta o que penso sobre sua liderança e gestão.",
    cultureQuestionEE13: "Sinto-me mais confortável em uma empresa com sindicato(s).",
    cultureQuestionEE14: "Escolher meus horários de entrada e saída é um fator chave para mim.",
    cultureQuestionEE15: "Sair mais cedo às sextas-feiras é um fator chave para mim.",
    cultureQuestionEE16: "Ter dias de folga além do legal em caso de casamento ou AUC é um fator chave para mim.",
    cultureQuestionEE17: "Ter os melhores benefícios para as mulheres pré e pós-natal é um fator chave para mim.",
    cultureQuestionEE18: "O fato de a empresa apoiar as atividades esportivas de seus funcionários é um fator fundamental para mim.",

    contractTypeEE: "Tipo de Contrato",

    //CareerPlan
    directorCP: "Diretor",
    managerCP: "Gerente",
    submanagerCP: "Subgerente",
    bossCP: "Chefe",
    specialistCP: "Especialista",
    analystCP: "Analista",
    operatorCP: "Operário / Técnico / Assist.",

    //InternalJobs
    emptyInternalJobs: "Ainda não há vagas publicadas",

    //InternalMessage
    emptyMessage: "Nenhuma mensagem",

    //Motivations
    motivationHeaderText:
      "MyDNA pode ajudá-lo a fazer Testes de Personalidade que o ajudam a criar um plano de desenvolvimento de carreira. Escreva-nos diretamente e nós o apoiaremos!",
    motivationOption1: "Opção 1 - Minha autoavaliação de Motivações",
    motivationOption1Text:
      "Por favor, dê uma nota de 1 a 10 para cada item, onde 1 indica que o item não é um fator importante para sua motivação profissional e 10 indica que é extremamente importante.",
    motivationInputError: "Insira um valor entre 1 e 10",
    motivationShowColab: "Mostrar os resultados da minha autoavaliação aos recrutadores",
    motivationOption2: "Opção 2 - Avaliação de Motivações MyCo  - Certificada por Especialistas",
    motivationOption2Text: "Forneça uma classificação de 1 a 10 para cada item, com base nos dados fornecidos em seu relatório Myco.",
    motivationShowMyCo: "Mostrar os resultados da avaliação MyCo aos recrutadores",

    //Abilities
    abilitiesHeaderText:
      "MyDNA pode ajudá-lo a fazer Testes de Habilidades que o ajudam a criar um plano de desenvolvimento de carreira. Escreva-nos diretamente e nós vamos te ajudar!",
    abilitiesOption1Text:
      "Por favor, dê uma nota de 1 a 10 para cada item, onde 1 indica que você sente que precisa melhorar aquela competência e 10 indica que você se considera muito proficiente nela.",
    abilitiesOption1: "Opção 1 - Minha autoavaliação de Habilidades",
    abilitiesInputError: "Insira um valor entre 1 e 10",
    abilitiesShowColab: "Mostrar os resultados da minha autoavaliação aos recrutadores",
    abilitiesOption2: "Opção 2 - Avaliação de Habilidades MyCo  - Certificada por Especialistas",
    abilitiesOption2Text: "Forneça uma classificação de 1 a 10 para cada item, com base nos dados fornecidos em seu relatório Myco.",
    abilitiesShowMyCo: "Mostrar os resultados da avaliação MyCo aos recrutadores",

    quoationMotivationsAbilitiesText:
      "Nossa ferramenta de avaliação fornece uma compreensão detalhada dos pontos fortes, fracos e oportunidades de crescimento. Oferece perspectivas sobre habilidades profissionais e cognitivas, e motivações. Ajuda no auto-aperfeiçoamento, identificação de áreas de desenvolvimento e preparação para futuras entrevistas de emprego.",
    downloadModel: "Baixar Modelo",
    getQuotation: "Solicitar Cotação",

    //CandidateCV
    emptyValueCV: "Campo não preenchido",
    professionalExperienceCV: "Experiência Profissional",
    formationCV: "Formação",
    purposeCV: "Propósito",
    cultureCV: "Cultura",
    knowledgeCV: "Conhecimento",
    languagesCV: "Idiomas",
    abilitiesCV: "Habilidades",
    motivationsCV: "Motivações",
    professionalHistoricCV: "Histórico Profissional",
    functionsCV: "Funções",
    achiviementsCV: "Conquistas",
    referencesCV: "Referências",
    shareButtonCV: "Compartilhar",

    //FirstLogin
    //WelcomePage
    welcomePageTitle: "Bem-vindo à plataforma profissional MyDNA!",
    welcomePageText:
      "Estamos muito felizes por ter você aqui. Sou seu assistente pessoal e irei apoiá-lo neste processo. Queremos conhecer você, entender quem você é, suas ambições e desafios!",
    welcomePageText2: "Vamos começar essa jornada juntos? Clique em `Iniciar` para começar sua integração.",
    welcomePageBtn: "Iniciar",
    welcomePageText4: "Ao preencher todas as suas informações, você receberá:",

    //InfoFirstLogin
    infoFirstLoginTitle: "As informações a seguir estão corretas?",
    infoFirstLoginText:
      "Dependendo do seu país e área de interesse, iremos conectá-lo(a) com empresas que estão em busca de profissionais com o seu perfil. Se você pretende participar de algum processo de seleção, elas poderão entrar em contato com você através desses meios. Certifique-se de que seus dados estão corretos.",
    infoFirstLoginName: "Nome",
    infoFirstLoginEmail: "E-mail",
    infoFirstLoginPhone: "Telefone",
    infoFirstLoginCountry: "País",
    infoFirstLoginAreas: "Áreas de Interesses",
    firstLoginBtn: "Continuar",

    //Step1FirstLogin
    step1FirstLogin: "Conte-nos sobre seu trabalho atual ou último desafio.",
    step1FirstLoginText:
      "Seu último cargo e empresa são cruciais para refletir suas habilidades atuais e são de grande interesse para os recrutadores na hora de selecionar perfis de destaque. Recomendamos que você forneça informações detalhadas sobre esta experiência, o que o fará se destacar dos demais candidatos.  Daqui para frente, você terá a oportunidade de agregar todas as experiências adquiridas.",
    step1Company: "Empresa *",
    step1Industry: "Indústria *",
    step1Position: "Cargo *",
    step1HierarchicalLevel: "Nível Hierárquico *",
    step1Area: "Área *",
    step1Working: "Trabalha aqui atualmente? *",
    step1StartDate: "Data de Ingresso *",
    step1EndDate: "Data de Saída *",

    //Step2FirstLogin
    step2Title: "Conte-nos sobre sua remuneração atual: temos interesse em conhecer seus salários fixos e variáveis.",
    step2Text:
      "No MyDNA, você não apenas informa os recrutadores. Posteriormente, iremos ajudá-lo a avaliar se o seu salário atual está alinhado com o mercado e iremos apoiá-lo no alinhamento das suas estratégias.",
    step2FixedSalary: "Salário Bruto Fixo *",
    step2VariableSalary: "Salário Variável *",

    //Step3FirstLogin
    step3FirstLoginTitle: "Conte-nos sobre sua formação mais relevante e seu nível de inglês.",
    step3FirstLoginText:
      "Essas informações são cruciais para identificar suas competências e, posteriormente, fornecer ideias valiosas para desenvolver sua carreira de acordo com seus objetivos profissionais.",
    step3Formation: "Formação",
    step3University: "Universidade *",
    step3Career: "Carreira *",
    step3Type: "Tipo *",
    step3Studing: "Cursando Atualmente? *",
    step3StartDate: "Data de Ingresso *",
    step3EndDate: "Data de Saída *",
    step3English: "Inglês",
    step3Level: "Nível *",
    step3Basic: "Básico",
    step3Intermediate: "Intermediário",
    step3Advanced: "Avançado",
    step3Fluent: "Fluente",

    //MiniProfile
    miniProfileText1: "Veja como está seu perfil!",
    miniProfileText2: "Continue completando para obter a versão completa!",
    miniProfileText3:
      "Quanto mais informações você adicionar, mais atrativo será o seu perfil e mais fácil será encontrar as vagas perfeitas para você. Sugerimos que você complete todas as seções da plataforma:",
    miniProfileText4: "Adicione mais experiências profissionais",
    miniProfileText5: "Realize testes de cultura e habilidades",
    miniProfileText6: "Adicione apresentação e referências",
    miniProfileText7: "Análise e Indicações de Vagas",
    miniProfileText8: "Curriculum personalizado",
    miniProfileText9: "Acesso total à plataforma",
    miniProfileText10: "Descubra todas as funções e ferramentas disponíveis para você!",
    miniProfileBtn: "Explorar Plataforma",
  },
};
